import ContractsCustomer from 'pages/Platform/Contracts/ContractsCustomer'
import { ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER } from '@/consts/rights'
import ContractsAgent from 'pages/Platform/Contracts/ContractsAgent'

export const ROUTE_NAME_PLATFORM_CONTRACTS_CUSTOMER = 'platformContractsCustomer'
export const ROUTE_NAME_PLATFORM_CONTRACTS_AGENT = 'platformContractsAgent'
export default [
  {
    path: 'customer',
    name: ROUTE_NAME_PLATFORM_CONTRACTS_CUSTOMER,
    component: ContractsCustomer,
    meta: {
      label: 'Client',
      isGranted: [
        ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER
      ]
    }
  },
  {
    path: 'agent',
    name: ROUTE_NAME_PLATFORM_CONTRACTS_AGENT,
    component: ContractsAgent,
    meta: {
      label: 'Agent',
      isGranted: [
        ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER
      ]
    }
  }
]
